import {InjectionToken} from "@angular/core";
import {IntNotificationsService} from "./services/int-notifications.service";
import {WINDOW_REF_TOKEN} from "../../tokens";

export const INT_NOTIFICATIONS_TOKEN = new InjectionToken('notif token');

export const INT_NOTIFICATIONS_PROVIDER = [{
  provide: IntNotificationsService,
  useClass: IntNotificationsService,
  deps: [WINDOW_REF_TOKEN]
}];
